/**
 * Wire type for a "Help me answer" message.
 *
 * A help request is an ordinary user message, not a separate transport: it travels the same
 * `onSubmit(content)` channel a selector reply does, so no selector needs a second callback
 * into the send lifecycle. `normalizeMessage` recognises this `type` and renders it as a
 * `helpRequest` bubble rather than dumping the raw JSON into the thread.
 */
export const HELP_REQUEST_TYPE = 'help-request';

/**
 * Builds the wire-content string for a help request.
 *
 * `options` carries the choices currently on screen so the assistant can talk about them by
 * name instead of re-deriving what it just offered. Only the names are sent — image URLs and
 * values are noise to the model and would bloat the prompt.
 */
export function buildHelpRequestPayload(
    selectorType: string,
    options?: ReadonlyArray<{ name: string }>
): string {
    return JSON.stringify({
        type: HELP_REQUEST_TYPE,
        data: { selectorType, ...(options !== undefined ? { options } : {}) },
    });
}
